export default "__VITE_ASSET__CqXo81tX__"